// @flow
import APIError from '../../client/APIError'
import client from '../../client'
import format from '../../utils/format'

// Types
import type { TCustomerProfile } from './getCustomerProfiles'

// API Endpoints
const CUSTOMER_PROFILE_ENDPOINT = '/travel_agent/profiles/{0}/'

/**
 * Returns an updated customer profile
 * @param {Object} data Customer profile information
 * @param {string} data.profile_id Customer profile ID
 * @param {string} data.profile_name Customer profile name
 * @param {string} data.first_name Customer profile first name
 * @param {string} data.last_name Customer profile last name
 * @param {string} data.email Customer profile email
 * @param {string} data.country_code_name Customer profile country code name
 * @param {string} data.phone_number_national Customer profile phone number
 * @return {Promise|Error} A resolved Promise with the customer profile updated or Rejected with an Error
 */
export const updateCustomerProfile = (
  data: {
    profile_id: number,
    profile_name?: string,
    first_name?: string,
    last_name?: string,
    email?: string,
    card_source_id?: string,
    country_code_name?: string,
    phone_number_national?: string,
  },
  source?: Object
): Promise<TCustomerProfile> => {
  const body = { ...data }
  const { profile_id } = data
  const endpoint = format(CUSTOMER_PROFILE_ENDPOINT, profile_id)

  if (source) {
    if (source.card.three_d_secure === 'required') {
      return Promise.reject(
        new APIError(
          'Card storing for 3DS cards is not supported, sorry',
          'card_not_supported',
          500
        )
      )
    }

    body.card_source_id = source.id
  }
  return client.patch(endpoint, { body })
}

export default updateCustomerProfile
